<div class="header__mobile-menu" [class.header__mobile-menu--open]="isOpen()">
  <nav class="header__mobile-nav" aria-label="Mobile navigation">
    <ul class="header__mobile-list">
      @for (item of menu(); track item.title) {
        <li class="header__mobile-item">
          @if (!item.children) {
            <a [routerLink]="item.link" class="header__mobile-link" (click)="navigated.emit()">
              {{ item.title | translate }}
            </a>
          }
          @if (item.children && item.children.length) {
            <div class="header__mobile-submenu">
              <button
                class="header__mobile-trigger"
                (click)="toggleSubmenu(item.title)"
                [attr.aria-expanded]="expandedItem() === item.title">
                {{ item.title | translate }}
                <mat-icon>{{ expandedItem() === item.title ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
              </button>
              <ul class="header__submenu-list" [class.header__submenu-list--expanded]="expandedItem() === item.title">
                @for (child of item.children; track child.link) {
                  <li>
                    <a class="header__submenu-link" [href]="child.link" (click)="navigated.emit()">
                      {{ child.title | translate }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </li>
      }
    </ul>
  </nav>
</div>
